import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background-color: ${({ theme }) => (theme as any).colors.differentBackground};
  color: ${({ theme }) => (theme as any).colors.primary};
  font-size: 16px;
  font: 400 16px "Inter", sans-serif;
  font-family: "Inter", sans-serif;
  text-rendering: geometricPrecision;
  font-feature-settings: "pnum";
  font-variant-numeric: proportional-nums;
  font-weight: normal;
  min-width: 280px;
  margin: 0;
  padding: 0;
  font-stretch: normal;
  font-style: normal;
  overscroll-behavior: none;
}

a {
  text-decoration: none;
  color: inherit;
  font-weight: 700;
  position: relative;
}

button,
input,
select,
textarea {
  -webkit-appearance: none;
  filter: none;
  border: none;
  outline: none;
  font-family: "Inter", sans-serif;
}

div[data-consent-manager-dialog] input {
  -webkit-appearance: auto;
}

button:focus,
input:focus {
  outline: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  background-color: ${({ theme }) =>
    (theme as any).colors.inputBackground} !important;
  color: ${({ theme }) => (theme as any).colors.primary} !important;
  -webkit-text-fill-color: ${({ theme }) =>
    (theme as any).colors.primary} !important;
  box-shadow: 0 0 0 1000px ${({ theme }) =>
    (theme as any).colors.inputBackground} inset !important;
  -webkit-box-shadow: 0 0 0 1000px ${({ theme }) =>
    (theme as any).colors.inputBackground} inset !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


.mb-5 {
  margin-bottom: 5px;
}
.mb-10 {
  margin-bottom: 5px;
}
.mb-15 {
  margin-bottom: 8px;
}
.mb-20 {
  margin-bottom: 10px;
}
.mb-30 {
  margin-bottom: 15px;
}
.mb-40 {
  margin-bottom: 20px;
}
.mb-50 {
  margin-bottom: 25px;
}
.mb-60 {
  margin-bottom: 30px;
}
.mb-70 {
  margin-bottom: 35px;
}
.mb-80 {
  margin-bottom: 40px;
}

.mt-5 {
  margin-top: 5px;
}
.mt-10 {
  margin-top: 5px;
}
.mt-15 {
  margin-top: 8px;
}
.mt-20 {
  margin-top: 10px;
}
.mt-30 {
  margin-top: 15px;
}
.mt-40 {
  margin-top: 20px;
}
.mt-50 {
  margin-top: 25px;
}
.mt-60 {
  margin-top: 30px;
}
.mt-70 {
  margin-top: 35px;
}
.mt-80 {
  margin-top: 40px;
}

@media only screen and (min-width:1280px) {
	.mb-5 {
    margin-bottom: 5px;
  }
	.mb-10 {
    margin-bottom: 10px;
  }
	.mb-15 {
    margin-bottom: 15px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-50 {
    margin-bottom: 50px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }
  .mb-70 {
    margin-bottom: 70px;
  }
  .mb-80 {
    margin-bottom: 80px;
  }

  .mt-5 {
    margin-top: 5px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .mt-15 {
    margin-top: 15px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mt-30 {
    margin-top: 30px;
  }
  .mt-40 {
    margin-top: 40px;
  }
  .mt-50 {
    margin-top: 50px;
  }
  .mt-60 {
    margin-top: 60px;
  }
  .mt-70 {
    margin-top: 70px;
  }
  .mt-80 {
    margin-top: 80px;
  }
}
`;

export default GlobalStyle;
